import React,{useEffect,useRef,useState} from "react";
import {useNavigate} from "react-router-dom";


/*
 * =====================================================
 * EDUNET USER-SPECIFIC RECENT SELECTION
 * =====================================================
 * Uses the logged-in student's identifier when one is
 * available, so one student's recent items do not affect
 * another student's homepage on the same browser.
 */
const getEdunetUserKey=()=>{

  const possibleKeys=[
    "user_id",
    "student_id",
    "logged_user_id",
    "current_user_id",
    "auth_user_id",
    "user",
    "student",
    "logged_user",
    "currentUser",
    "auth_user",
    "student_data"
  ];

  for(const key of possibleKeys){

    try{

      const raw=localStorage.getItem(key);

      if(!raw){
        continue;
      }

      try{

        const parsed=JSON.parse(raw);

        if(parsed && typeof parsed==="object"){

          const id=
            parsed.user_id ??
            parsed.student_id ??
            parsed.id ??
            parsed.userId ??
            parsed.studentId ??
            parsed.email;

          if(id!==undefined && id!==null && String(id).trim()!==""){
            return String(id);
          }

        }

      }catch(error){

        if(String(raw).trim()!==""){
          return String(raw);
        }

      }

    }catch(error){}

  }

  return "guest";
};


function TeacherDemo(){

  const navigate=useNavigate();

  const [darkMode,setDarkMode]=useState(()=>{
    try{
      return localStorage.getItem("teacher_demo_theme")!=="light";
    }catch(error){
      return true;
    }
  });

  const [selectedItem,setSelectedItem]=useState(null);
  const [selectedType,setSelectedType]=useState("");
  const [searchOpen,setSearchOpen]=useState(false);
  const [searchText,setSearchText]=useState("");
  const [mobileMenuOpen,setMobileMenuOpen]=useState(false);
  const [activeNav,setActiveNav]=useState("Home");
  const [accountName,setAccountName]=useState("Kids");

  const [recentDemoItems,setRecentDemoItems]=useState(()=>{

    try{

      const key=
        `edunet_recent_demo_items_${getEdunetUserKey()}`;

      const raw=localStorage.getItem(key);

      if(raw){
        const parsed=JSON.parse(raw);

        if(parsed && typeof parsed==="object"){
          return parsed;
        }
      }

    }catch(error){}

    return {
      School:null,
      Teacher:null,
      Lesson:null
    };

  });


  const [popupPosition,setPopupPosition]=useState({
    top:0,
    left:0
  });

  const [scrollPositions,setScrollPositions]=useState({
    Schools:0,
    Teachers:0,
    Lessons:0
  });

  const rowRefs=useRef({});
  const selectedCardRef=useRef(null);
  const popupRef=useRef(null);
  const closeTimerRef=useRef(null);

  const videoRef=useRef(null);
  const largeVideoRef=useRef(null);
  const previewStartTimerRef=useRef(null);
  const previewLoaderTimerRef=useRef(null);

  const [videoMuted,setVideoMuted]=useState(true);
  const [showPreviewVideo,setShowPreviewVideo]=useState(false);
  const [videoCanPlay,setVideoCanPlay]=useState(false);
  const [videoReady,setVideoReady]=useState(false);

  // Large Netflix-style video modal
  const [showLargeVideo,setShowLargeVideo]=useState(false);

  const previewVideos={
    School:"/build/school-preview.mp4",
    Teacher:"/build/teacher-preview.mp4",
    Lesson:"/build/lesson-preview.mp4"
  };

  const fallbackSchoolImage=
    "https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&w=1600&h=900&q=90";

  const fallbackTeacherImage=
    "https://images.unsplash.com/photo-1511629091441-ee46146481b6?auto=format&fit=crop&w=1600&h=900&q=90";

  const fallbackLessonImage=
    "https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=1200&h=675&q=90";

  const schoolData=[
    {
      id:1,
      name:"Ananda College",
      location:"Colombo",
      type:"School",
      image:"https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&w=1600&h=900&q=90",
      students:"6,500+",
      teachers:"300+",
      rank:"#01",
      subjects:"25+",
      lessons:"120+"
    },
    {
      id:2,
      name:"Nalanda College",
      location:"Colombo",
      type:"School",
      image:"https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?auto=format&fit=crop&w=1600&h=900&q=90",
      students:"5,800+",
      teachers:"280+",
      rank:"#02",
      subjects:"24+",
      lessons:"110+"
    },
    {
      id:3,
      name:"Royal College",
      location:"Colombo",
      type:"School",
      image:"https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=1600&h=900&q=90",
      students:"8,200+",
      teachers:"350+",
      rank:"#03",
      subjects:"28+",
      lessons:"145+"
    },
    {
      id:4,
      name:"Visakha Vidyalaya",
      location:"Colombo",
      type:"School",
      image:"https://images.unsplash.com/photo-1592280771190-3e2e4d571952?auto=format&fit=crop&w=1600&h=900&q=90",
      students:"4,900+",
      teachers:"240+",
      rank:"#04",
      subjects:"22+",
      lessons:"95+"
    },
    {
      id:5,
      name:"D.S. Senanayake College",
      location:"Colombo",
      type:"School",
      image:"https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=1600&h=900&q=90",
      students:"4,700+",
      teachers:"230+",
      rank:"#05",
      subjects:"21+",
      lessons:"90+"
    },
    {
      id:6,
      name:"Isipathana College",
      location:"Colombo",
      type:"School",
      image:"https://images.unsplash.com/photo-1527576539890-dfa815648363?auto=format&fit=crop&w=1600&h=900&q=90",
      students:"4,500+",
      teachers:"220+",
      rank:"#06",
      subjects:"20+",
      lessons:"88+"
    },
    {
      id:7,
      name:"Mahinda College",
      location:"Galle",
      type:"School",
      image:"https://images.unsplash.com/photo-1564981797816-1043664bf78d?auto=format&fit=crop&w=1600&h=900&q=90",
      students:"4,300+",
      teachers:"210+",
      rank:"#07",
      subjects:"19+",
      lessons:"82+"
    },
    {
      id:8,
      name:"Maliyadeva College",
      location:"Kurunegala",
      type:"School",
      image:"https://images.unsplash.com/photo-1606761568499-6d2451b23c66?auto=format&fit=crop&w=1600&h=900&q=90",
      students:"5,100+",
      teachers:"250+",
      rank:"#08",
      subjects:"23+",
      lessons:"100+"
    }
  ];

  const teacherData=[
    {
      id:101,
      name:"Mr. Perera",
      subject:"Mathematics",
      grade:"Grade 1 - 5",
      type:"Teacher",
      image:"https://images.unsplash.com/photo-1511629091441-ee46146481b6?auto=format&fit=crop&w=1600&h=900&q=90"
    },
    {
      id:102,
      name:"Ms. Shani",
      subject:"English",
      grade:"Grade 1 - 5",
      type:"Teacher",
      image:"https://images.unsplash.com/photo-1783094269325-4ba186e8e01b?auto=format&fit=crop&w=1600&h=900&q=90"
    },
    {
      id:103,
      name:"Mr. Lahiru",
      subject:"Science",
      grade:"Grade 6 - 11",
      type:"Teacher",
      image:"https://images.unsplash.com/photo-1758270703988-9503117c1d0c?auto=format&fit=crop&w=1600&h=900&q=90"
    },
    {
      id:104,
      name:"Ms. Nethmi",
      subject:"Sinhala",
      grade:"Grade 6 - 11",
      type:"Teacher",
      image:"https://images.unsplash.com/photo-1758685848006-1bc450061624?auto=format&fit=crop&w=1600&h=900&q=90"
    },
    {
      id:105,
      name:"Mr. Gayan",
      subject:"Physics",
      grade:"Grade 12 - 13",
      type:"Teacher",
      image:"https://images.unsplash.com/photo-1758270703988-9503117c1d0c?auto=format&fit=crop&w=1600&h=900&q=90"
    },
    {
      id:106,
      name:"Ms. Piumi",
      subject:"Chemistry",
      grade:"Grade 12 - 13",
      type:"Teacher",
      image:"https://images.unsplash.com/photo-1758685848142-06e158cf64bc?auto=format&fit=crop&w=1600&h=900&q=90"
    },
    {
      id:107,
      name:"Mr. Malith",
      subject:"ICT",
      grade:"Grade 10 - 13",
      type:"Teacher",
      image:"https://images.unsplash.com/photo-1511629091441-ee46146481b6?auto=format&fit=crop&w=1600&h=900&q=90"
    },
    {
      id:108,
      name:"Ms. Dilki",
      subject:"History",
      grade:"Grade 6 - 11",
      type:"Teacher",
      image:"https://images.unsplash.com/photo-1758685848006-1bc450061624?auto=format&fit=crop&w=1600&h=900&q=90"
    }
  ];

  const lessonData=[
    {
      id:201,
      name:"Mathematics Basics",
      subject:"Mathematics",
      grade:"Grade 1 - 5",
      type:"Lesson",
      image:"https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=1200&h=675&q=90"
    },
    {
      id:202,
      name:"Introduction to Science",
      subject:"Science",
      grade:"Grade 6 - 9",
      type:"Lesson",
      image:"https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=1200&h=675&q=90"
    },
    {
      id:203,
      name:"English Grammar",
      subject:"English",
      grade:"Grade 6 - 11",
      type:"Lesson",
      image:"https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=1200&h=675&q=90"
    },
    {
      id:204,
      name:"Physics Motion",
      subject:"Physics",
      grade:"Grade 12 - 13",
      type:"Lesson",
      image:"https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?auto=format&fit=crop&w=1200&h=675&q=90"
    },
    {
      id:205,
      name:"Organic Chemistry",
      subject:"Chemistry",
      grade:"Grade 12 - 13",
      type:"Lesson",
      image:"https://images.unsplash.com/photo-1603126857599-f6e157fa2fe6?auto=format&fit=crop&w=1200&h=675&q=90"
    },
    {
      id:206,
      name:"ICT Fundamentals",
      subject:"ICT",
      grade:"Grade 10 - 13",
      type:"Lesson",
      image:"https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&h=675&q=90"
    },
    {
      id:207,
      name:"World History",
      subject:"History",
      grade:"Grade 6 - 11",
      type:"Lesson",
      image:"https://images.unsplash.com/photo-1461360370896-922624d12aa1?auto=format&fit=crop&w=1200&h=675&q=90"
    },
    {
      id:208,
      name:"Algebra Masterclass",
      subject:"Mathematics",
      grade:"Grade 10 - 13",
      type:"Lesson",
      image:"https://images.unsplash.com/photo-1509228468518-180dd4864904?auto=format&fit=crop&w=1200&h=675&q=90"
    }
  ];

  const getSchoolStats=(item)=>{

    if(!item || item.type!=="School"){
      return null;
    }

    return {
      students:item.students || "—",
      teachers:item.teachers || "—",
      rank:item.rank || "—",
      subjects:item.subjects || "—",
      lessons:item.lessons || "—"
    };

  };

  const rows=[
    {
      title:"Schools",
      type:"School",
      items:schoolData
    },
    {
      title:"Teachers",
      type:"Teacher",
      items:teacherData
    },
    {
      title:"Lessons",
      type:"Lesson",
      items:lessonData
    }
  ];

  const normalizeSearch=(value)=>{
    return String(value||"")
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g," ")
      .replace(/\s+/g," ")
      .trim();
  };

  const search=normalizeSearch(searchText);

  /*
   * Put the last selected School / Teacher / Lesson first.
   * This is loaded per logged-in user and survives a new
   * visit to the site.
   */
  const rememberRecentDemoItem=(type,item)=>{

    if(!item || !type){
      return;
    }

    const next={

      ...recentDemoItems,

      [type]:String(item.id)

    };

    setRecentDemoItems(next);

    try{

      const key=
        `edunet_recent_demo_items_${getEdunetUserKey()}`;

      localStorage.setItem(
        key,
        JSON.stringify(next)
      );

    }catch(error){}

  };

  const orderedRows=rows.map(row=>{

    const recentId=
      recentDemoItems[row.type];

    if(!recentId){
      return row;
    }

    const recentIndex=
      row.items.findIndex(
        item=>String(item.id)===String(recentId)
      );

    if(recentIndex<=0){
      return row;
    }

    const recentItem=
      row.items[recentIndex];

    return {

      ...row,

      items:[
        recentItem,
        ...row.items.filter(
          (_,index)=>index!==recentIndex
        )
      ]

    };

  });

  const filteredRows=orderedRows.map(row=>({

    ...row,

    items:row.items.filter(item=>{

      if(!search){
        return true;
      }

      const name=normalizeSearch(item.name);
      const subject=normalizeSearch(item.subject);
      const grade=normalizeSearch(item.grade);
      const location=normalizeSearch(item.location);

      return(
        name.includes(search)||
        subject.includes(search)||
        grade.includes(search)||
        location.includes(search)
      );

    })

  }));

  const handleRowScroll=(title,event)=>{

    const element=event.currentTarget;

    const maxScroll=
      element.scrollWidth-
      element.clientWidth;

    if(maxScroll<=0){

      setScrollPositions(prev=>({
        ...prev,
        [title]:0
      }));

      return;
    }

    const percentage=
      element.scrollLeft/maxScroll;

    setScrollPositions(prev=>({
      ...prev,
      [title]:percentage
    }));

  };

  useEffect(()=>{

    const updateAllRows=()=>{

      Object.keys(rowRefs.current).forEach(title=>{

        const element=rowRefs.current[title];

        if(!element){
          return;
        }

        const maxScroll=
          element.scrollWidth-
          element.clientWidth;

        if(maxScroll<=0){

          setScrollPositions(prev=>({
            ...prev,
            [title]:0
          }));

          return;
        }

        const percentage=
          element.scrollLeft/maxScroll;

        setScrollPositions(prev=>({
          ...prev,
          [title]:percentage
        }));

      });

    };

    updateAllRows();

    window.addEventListener(
      "resize",
      updateAllRows
    );

    return()=>{

      window.removeEventListener(
        "resize",
        updateAllRows
      );

    };

  },[filteredRows]);

  const handleImageError=(event,type)=>{

    if(
      event.currentTarget.dataset
        .fallbackApplied==="true"
    ){
      return;
    }

    event.currentTarget.dataset
      .fallbackApplied="true";

    if(type==="Teacher"){

      event.currentTarget.src=
        fallbackTeacherImage;

      return;
    }

    if(type==="Lesson"){

      event.currentTarget.src=
        fallbackLessonImage;

      return;
    }

    event.currentTarget.src=
      fallbackSchoolImage;

  };

  const clearCloseTimer=()=>{

    if(closeTimerRef.current){

      clearTimeout(
        closeTimerRef.current
      );

      closeTimerRef.current=null;

    }

  };

  const closePopup=()=>{

    clearCloseTimer();

    setSelectedItem(null);
    setSelectedType("");

    selectedCardRef.current=null;

  };

  /*
   * =====================================================
   * VIDEO PLAYBACK
   * =====================================================
   */

  useEffect(()=>{

    if(previewStartTimerRef.current){
      clearTimeout(previewStartTimerRef.current);
      previewStartTimerRef.current=null;
    }

    if(previewLoaderTimerRef.current){
      clearTimeout(previewLoaderTimerRef.current);
      previewLoaderTimerRef.current=null;
    }

    if(!selectedItem || !selectedType){

      setShowPreviewVideo(false);
      setVideoReady(false);
      setVideoCanPlay(false);

      if(videoRef.current){
        videoRef.current.pause();
        videoRef.current.currentTime=0;
      }

      return;
    }

    // Keep the selected image visible first.
    // After 2.5 seconds, smoothly switch to the preview video.
    setShowPreviewVideo(false);
    setVideoReady(false);
    setVideoCanPlay(false);
    setVideoMuted(true);

    previewStartTimerRef.current=setTimeout(()=>{

      previewStartTimerRef.current=null;

      if(!videoRef.current){
        return;
      }

      setShowPreviewVideo(true);

      videoRef.current.muted=true;
      videoRef.current.currentTime=0;
      videoRef.current.defaultPlaybackRate=.85;
      videoRef.current.playbackRate=.85;

      setVideoReady(true);
      setVideoCanPlay(true);

      videoRef.current.play().catch(()=>{});

    },2500);

    return()=>{

      if(previewStartTimerRef.current){
        clearTimeout(previewStartTimerRef.current);
        previewStartTimerRef.current=null;
      }

      if(previewLoaderTimerRef.current){
        clearTimeout(previewLoaderTimerRef.current);
        previewLoaderTimerRef.current=null;
      }

      if(videoRef.current){
        videoRef.current.pause();
        videoRef.current.currentTime=0;
      }

      setShowPreviewVideo(false);
      setVideoReady(false);

    };

  },[selectedItem,selectedType]);

  useEffect(()=>{

    if(!showLargeVideo || !showPreviewVideo){
      return;
    }

    const video=largeVideoRef.current;

    if(!video){
      return;
    }

    video.muted=true;
    video.currentTime=0;
    video.defaultPlaybackRate=.85;
    video.playbackRate=.85;
    video.play().catch(()=>{});

    return()=>{
      video.pause();
    };

  },[showLargeVideo,showPreviewVideo,selectedItem,selectedType]);

  const updatePopupPosition=()=>{

    if(!selectedCardRef.current){
      return;
    }

    const card=
      selectedCardRef.current;

    const cardRect=
      card.getBoundingClientRect();

    const screenWidth=
      window.innerWidth;

    const screenHeight=
      window.innerHeight;

    let popupWidth=378;
    let popupHeight=378;

    if(screenWidth<=768){

      popupWidth=
        Math.min(
          378,
          screenWidth-20
        );

    }

    if(popupRef.current){

      popupHeight=
        popupRef.current.offsetHeight;

    }

    let left=
      cardRect.left+
      (
        cardRect.width-
        popupWidth
      )/2;

    let top=
      cardRect.top-30;

    if(left<10){
      left=10;
    }

    if(
      left+popupWidth>
      screenWidth-10
    ){

      left=
        screenWidth-
        popupWidth-
        10;

    }

    if(screenWidth<=768){

      left=
        (
          screenWidth-
          popupWidth
        )/2;

      top=
        cardRect.top-25;

    }

    if(top<10){
      top=10;
    }

    if(
      top+popupHeight>
      screenHeight-10
    ){

      top=Math.max(
        10,
        screenHeight-
        popupHeight-
        10
      );

    }

    setPopupPosition({
      top,
      left
    });

  };

  const handleItemHover=(
    item,
    type,
    cardElement
  )=>{

    clearCloseTimer();

    selectedCardRef.current=
      cardElement;

    setSelectedItem(item);
    setSelectedType(type);

  };

  const handleItemClick=(item,type)=>{

    clearCloseTimer();

    // Remember the last item the logged-in user selected.
    // It will appear first in this row on the next visit.
    rememberRecentDemoItem(type,item);

    setSelectedItem(item);
    setSelectedType(type);

    setShowLargeVideo(true);

  };

  const handleItemLeave=()=>{

    // Do not close anything while the large details modal is open.
    // The modal must stay open until the user closes it.
    if(showLargeVideo){
      clearCloseTimer();
      return;
    }

    clearCloseTimer();

    closeTimerRef.current=
      setTimeout(()=>{

        if(showLargeVideo){
          return;
        }

        if(
          popupRef.current &&
          popupRef.current.matches(":hover")
        ){
          return;
        }

        closePopup();

      },250);

  };

  const handlePopupMouseEnter=()=>{
    clearCloseTimer();
  };

  const handlePopupMouseLeave=()=>{

    // Keep the large modal open.
    if(showLargeVideo){
      clearCloseTimer();
      return;
    }

    clearCloseTimer();

    closeTimerRef.current=
      setTimeout(()=>{

        if(showLargeVideo){
          return;
        }

        closePopup();

      },150);

  };

  useEffect(()=>{

    if(!selectedItem){
      return;
    }

    const timer=
      setTimeout(()=>{

        updatePopupPosition();

      },0);

    const handleResize=()=>{
      updatePopupPosition();
    };

    const handleScroll=()=>{
      updatePopupPosition();
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    window.addEventListener(
      "scroll",
      handleScroll,
      true
    );

    return()=>{

      clearTimeout(timer);

      window.removeEventListener(
        "resize",
        handleResize
      );

      window.removeEventListener(
        "scroll",
        handleScroll,
        true
      );

    };

  },[selectedItem,showLargeVideo]);

  useEffect(()=>{

    try{

      localStorage.setItem(
        "teacher_demo_theme",
        darkMode
          ?"dark"
          :"light"
      );

    }catch(error){}

    document.body.style.backgroundColor=
      darkMode
        ?"#141414"
        :"#8fb8e6";

    document.documentElement.style.backgroundColor=
      darkMode
        ?"#141414"
        :"#8fb8e6";

  },[darkMode]);

  useEffect(()=>{

    return()=>{

      clearCloseTimer();

      if(previewStartTimerRef.current){

        clearTimeout(
          previewStartTimerRef.current
        );

      }

      if(videoRef.current){

        videoRef.current.pause();
        videoRef.current.currentTime=0;

      }

    };

  },[]);

  /*
   * =====================================================
   * NAVIGATION
   * =====================================================
   */

  const handleNavClick=(item)=>{

    setActiveNav(item);

    setMobileMenuOpen(false);

    if(item==="Home"){

      setSearchText("");
      setSearchOpen(false);

    }

    if(item==="Teachers"){

      setSearchText("");
      setSearchOpen(true);

    }

    if(item==="Subjects"){

      setSearchText("");
      setSearchOpen(true);

    }

    if(item==="My Learning"){

      setSearchText("");
      setSearchOpen(false);

    }

  };

  return(

    <div
      className={
        `teacher-demo-page ${
          darkMode
            ?"dark-mode"
            :"light-mode"
        }`
      }
    >

      <style>{`

        *{
          box-sizing:border-box;
        }

        html,
        body{
          margin:0;
          padding:0;
          background:#141414;
        }

        body{
          overflow-x:hidden;
        }

        .teacher-demo-page{
          min-height:100vh;
          padding:0 48px 70px;
          background:#141414;
          color:#fff;
          overflow-x:hidden;
          font-family:
            Arial,
            Helvetica,
            sans-serif;
        }

        /* =================================================
           NAVBAR
        ================================================= */

        .teacher-demo-navbar{
          position:sticky;
          top:0;
          z-index:5000;

          height:72px;

          margin:
            0 -48px 27px;

          padding:
            0 48px;

          display:flex;

          align-items:center;

          justify-content:space-between;

          background:
            linear-gradient(
              180deg,
              #050505 0%,
              #080808 100%
            );

          border-bottom:
            1px solid
            rgba(255,255,255,.08);

          backdrop-filter:blur(12px);

          -webkit-backdrop-filter:blur(12px);
        }

        .teacher-demo-navbar-left{
          display:flex;
          align-items:center;
          gap:32px;
          min-width:0;
        }

        .teacher-netflix-logo{
          color:#e50914;
          font-size:26px;
          font-weight:900;
          letter-spacing:-1.5px;
          line-height:1;
          white-space:nowrap;
          visibility:hidden;
        }

        .teacher-demo-menu{
          display:flex;
          align-items:center;
          gap:8px;
        }

        .teacher-demo-menu button{
          border:none;
          background:transparent;
          padding:10px 17px;
          color:rgba(255,255,255,.68);
          font-size:16px;
          line-height:20px;
          font-weight:500;
          cursor:pointer;

          transition:
            background .2s ease,
            color .2s ease;

          border-radius:24px;
          white-space:nowrap;
        }

        .teacher-demo-menu button:hover{
          background:rgba(255,255,255,.08);
          color:#fff;
        }

        .teacher-demo-menu button.active{
          background:#333338;
          color:#fff;
          font-weight:700;
        }

        /* =================================================
           NAVBAR RIGHT
        ================================================= */

        .teacher-demo-navbar-right{
          display:flex;
          align-items:center;
          gap:11px;
        }

        /* =================================================
           MOBILE MENU BUTTON
        ================================================= */

        .teacher-mobile-menu-button{
          display:none;

          width:38px;
          height:38px;

          border:none;
          border-radius:50%;

          background:transparent;

          color:#fff;

          align-items:center;
          justify-content:center;

          cursor:pointer;

          padding:0;

          flex-shrink:0;

          transition:
            background .2s ease;
        }

        .teacher-mobile-menu-button:hover,
        .teacher-mobile-menu-button.active{
          background:#333338;
        }

        .teacher-mobile-menu-button svg{
          width:23px;
          height:23px;
          display:block;
        }

        /* =================================================
           MOBILE MENU PANEL
        ================================================= */

        .teacher-mobile-menu-panel{
          display:none;

          position:fixed;

          top:72px;

          left:12px;
          right:12px;

          z-index:4999;

          padding:8px;

          background:#181818;

          border:
            1px solid
            rgba(255,255,255,.12);

          border-radius:8px;

          box-shadow:
            0 15px 40px
            rgba(0,0,0,.65);
        }

        .teacher-mobile-menu-panel button{
          width:100%;

          height:44px;

          border:none;

          border-radius:6px;

          background:transparent;

          color:#ddd;

          text-align:left;

          padding:
            0 14px;

          font-size:15px;

          cursor:pointer;

          transition:
            background .2s ease,
            color .2s ease;
        }

        .teacher-mobile-menu-panel button:hover{
          background:#292929;
          color:#fff;
        }

        .teacher-mobile-menu-panel button.active{
          background:#333338;
          color:#fff;
          font-weight:600;
        }

        /* =================================================
           THEME
        ================================================= */

        .teacher-theme-toggle{
          width:38px;
          height:38px;

          border:none;
          border-radius:50%;

          background:transparent;

          color:#fff;

          display:flex;

          align-items:center;
          justify-content:center;

          cursor:pointer;

          padding:0;

          transition:
            background .2s ease,
            color .2s ease,
            transform .2s ease;

          flex-shrink:0;
        }

        .teacher-theme-toggle:hover{
          background:#333338;
          transform:rotate(8deg);
        }

        .teacher-theme-toggle svg{
          width:21px;
          height:21px;

          display:block;

          stroke:currentColor;

          stroke-width:1.8;

          stroke-linecap:round;

          stroke-linejoin:round;
        }

        /* =================================================
           SEARCH
        ================================================= */

        .teacher-search-area{
          display:flex;
          align-items:center;
          gap:8px;
        }

        .teacher-search-input{
          width:220px;
          height:36px;

          border:
            1px solid
            rgba(255,255,255,.25);

          border-radius:4px;

          outline:none;

          background:#181818;

          color:#fff;

          padding:
            0 11px;

          font-size:14px;
        }

        .teacher-search-input::placeholder{
          color:rgba(255,255,255,.5);
        }

        .teacher-nav-icon{
          width:38px;
          height:38px;

          border:none;

          background:transparent;

          color:#fff;

          display:flex;

          align-items:center;
          justify-content:center;

          cursor:pointer;

          border-radius:50%;

          padding:0;

          flex-shrink:0;
        }

        .teacher-nav-icon:hover,
        .teacher-nav-icon.active{
          background:#333338;
        }

        .teacher-nav-svg{
          width:24px;
          height:24px;
          display:block;
        }

        .teacher-search-icon{
          width:25px;
          height:25px;
        }

        .teacher-notification-icon{
          width:23px;
          height:23px;
        }

        /* =================================================
           KIDS
        ================================================= */

        .teacher-kids-item{
          height:38px;
          min-width:38px;

          display:flex;

          align-items:center;
          justify-content:center;

          gap:7px;

          padding:
            0 7px;

          color:#fff;

          background:transparent;

          border:none;

          cursor:pointer;

          border-radius:6px;

          transition:
            background .2s ease;

          flex-shrink:0;
        }

        .teacher-kids-item:hover{
          background:#333338;
        }

        .teacher-kids-logo{
          width:32px;
          height:32px;

          border-radius:4px;

          overflow:hidden;

          display:flex;

          align-items:center;
          justify-content:center;

          background:
            linear-gradient(
              135deg,
              #8d42b9 0%,
              #d34f9d 48%,
              #f3b33d 48%,
              #f3b33d 100%
            );

          flex-shrink:0;
        }

        .teacher-kids-logo span{
          color:#fff;

          font-size:9px;

          font-weight:800;

          background:
            rgba(220,60,170,.75);

          padding:
            2px 1px;
        }

        .teacher-kids-text{
          font-size:16px;
          font-weight:500;
          white-space:nowrap;
        }

        .teacher-kids-arrow{
          width:9px;
          height:9px;
        }

        /* =================================================
           PROFILE
        ================================================= */

        .teacher-profile-icon{
          width:38px;
          height:38px;

          border-radius:6px;

          display:flex;

          align-items:center;
          justify-content:center;

          background:#f2c900;

          color:#fff;

          cursor:pointer;

          transition:
            background .2s ease;

          flex-shrink:0;
        }

        .teacher-profile-icon:hover{
          background:#dcb600;
        }

        .teacher-profile-svg{
          width:24px;
          height:24px;
        }

        .teacher-profile-arrow{
          width:10px;
          height:10px;

          color:#aaa;

          margin-left:-4px;
        }

        /* =================================================
           CATEGORY
        ================================================= */

        .teacher-category{
          position:relative;
          margin-bottom:30px;
        }

        .teacher-category-header{
          display:flex;

          align-items:center;

          justify-content:space-between;

          margin-bottom:11px;

          min-height:28px;
        }

        .teacher-category-title{
          margin:0;

          font-size:22px;

          line-height:1.25;

          font-weight:700;

          color:#fff;

          letter-spacing:-.2px;
        }

        /* =================================================
           SCROLL INDICATOR
        ================================================= */

        .teacher-scroll-indicator{
          display:flex;

          align-items:center;

          justify-content:flex-end;

          gap:2px;

          height:12px;

          min-width:95px;

          margin-right:2px;

          pointer-events:none;
        }

        .scroll-dash{
          width:10px;
          height:2px;

          background:
            rgba(255,255,255,.32);

          border-radius:1px;

          flex-shrink:0;

          transition:
            background .18s ease,
            opacity .18s ease,
            transform .18s ease;
        }

        .scroll-dash.active{
          background:#fff;

          opacity:1;

          transform:
            scaleX(1.05);
        }

        /* =================================================
           ROW
        ================================================= */

        .teacher-row-wrapper{
          position:relative;

          width:100%;

          overflow:visible;
        }

        .teacher-row{
          display:flex;

          flex-wrap:nowrap;

          gap:9px;

          overflow-x:auto;
          overflow-y:hidden;

          padding:
            7px 0 10px;

          margin:0;

          scrollbar-width:none;

          scroll-behavior:smooth;

          -webkit-overflow-scrolling:touch;
        }

        .teacher-row::-webkit-scrollbar{
          display:none;
        }

        /* =================================================
           CARD
        ================================================= */

        .teacher-card{
          position:relative;

          width:
            calc(
              (100vw - 96px - 45px) / 6
            );

          min-width:215px;

          aspect-ratio:16 / 9;

          flex:
            0 0
            calc(
              (100vw - 96px - 45px) / 6
            );

          border-radius:7px;

          overflow:hidden;

          background:#181818;

          cursor:pointer;

          transition:
            transform .25s ease,
            box-shadow .25s ease;

          z-index:1;
        }

        .teacher-card:hover{
          transform:scale(1.035);

          box-shadow:
            0 12px 30px
            rgba(0,0,0,.78);

          z-index:100;
        }

        .teacher-image-box{
          width:100%;
          height:100%;

          overflow:hidden;

          background:#181818;
        }

        .teacher-image{
          width:100%;
          height:100%;

          display:block;

          object-fit:cover;

          object-position:center center;

          transform:scale(1);

          transition:
            transform .35s ease;
        }

        .teacher-card:hover
        .teacher-image{
          transform:scale(1.02);
        }

        .teacher-card::after{
          content:"";

          position:absolute;

          left:0;
          right:0;
          bottom:0;

          height:58%;

          background:
            linear-gradient(
              transparent 0%,
              rgba(0,0,0,.10) 32%,
              rgba(0,0,0,.88) 100%
            );

          pointer-events:none;
        }

        .teacher-card-badge{
          position:absolute;

          top:7px;
          left:7px;

          z-index:10;

          background:#e50914;

          color:#fff;

          padding:
            3px 6px;

          border-radius:3px;

          font-size:9px;

          font-weight:800;

          text-transform:uppercase;
        }

        .teacher-card-small-info{
          position:absolute;

          left:12px;
          bottom:29px;
          right:10px;

          z-index:20;

          font-size:10px;

          color:
            rgba(255,255,255,.82);

          white-space:nowrap;

          overflow:hidden;

          text-overflow:ellipsis;
        }

        .teacher-card-name{
          position:absolute;

          left:12px;
          bottom:9px;
          right:10px;

          z-index:20;

          font-size:16px;

          font-weight:700;

          color:#fff;

          text-shadow:
            0 2px 6px
            rgba(0,0,0,.95);

          white-space:nowrap;

          overflow:hidden;

          text-overflow:ellipsis;
        }

        /* =================================================
           POPUP
        ================================================= */

        .teacher-selected-popup{
          position:fixed;

          width:378px;
          height:378px;

          background:#181818;

          border-radius:7px;

          overflow:hidden;

          box-shadow:
            0 20px 60px
            rgba(0,0,0,.9);

          z-index:999999;

          animation:
            teacherPopupOpen .18s ease;

          pointer-events:auto;
        }

        @keyframes teacherPopupOpen{

          from{
            opacity:0;
            transform:scale(.94);
          }

          to{
            opacity:1;
            transform:scale(1);
          }

        }

        .teacher-popup-image-wrapper{
          position:relative;

          width:100%;

          height:212px;

          background:#181818;

          overflow:hidden;

          cursor:pointer;
        }

        .teacher-popup-image{
          position:absolute;

          inset:0;

          width:100%;
          height:100%;

          display:block;

          object-fit:cover;

          object-position:center center;

          transition:
            opacity .7s ease;
        }

        /* =================================================
           POPUP VIDEO
        ================================================= */

        .teacher-popup-video{
          position:absolute;

          cursor:pointer;

          inset:0;

          width:100%;
          height:100%;

          display:block;

          object-fit:cover;

          object-position:center center;

          background:#000;

          z-index:5;

          opacity:0;

          transform:scale(1.035);

          transition:
            opacity 1.35s ease,
            transform 1.5s cubic-bezier(.22,1,.36,1);

          pointer-events:none;
        }

        .teacher-popup-video.video-ready{
          opacity:1;

          transform:scale(1);
        }

        /* =================================================
           POPUP CONTENT
        ================================================= */

        .teacher-popup-content{
          position:relative;

          height:
            calc(
              378px - 212px
            );

          padding:
            8px 14px 12px;

          z-index:20;

          background:#181818;
        }

        .teacher-buttons{
          display:flex;

          gap:7px;

          margin-bottom:8px;
        }

        .teacher-buttons button{
          width:32px;
          height:32px;

          border-radius:50%;

          border:
            1px solid
            rgba(255,255,255,.45);

          background:
            rgba(255,255,255,.1);

          color:#fff;

          cursor:pointer;

          display:flex;

          align-items:center;
          justify-content:center;

          font-size:13px;

          padding:0;
        }

        .teacher-buttons button:hover{
          background:#fff;
          color:#000;
        }

        .teacher-popup-content h3{
          margin:
            0 0 6px;

          font-size:18px;

          line-height:1.15;

          font-weight:700;

          color:#fff;
        }

        .teacher-details{
          display:flex;

          flex-direction:column;

          gap:3px;

          margin-bottom:6px;

          font-size:11px;

          line-height:1.25;
        }

        .teacher-detail-row{
          display:flex;

          gap:5px;

          min-height:14px;
        }

        .teacher-detail-label{
          color:#fff;
          font-weight:700;
        }

        .teacher-detail-value{
          color:#cfcfcf;
        }

        .teacher-description{
          margin:0;

          font-size:10px;

          line-height:1.35;

          color:#cfcfcf;

          display:-webkit-box;

          -webkit-line-clamp:2;

          -webkit-box-orient:vertical;

          overflow:hidden;
        }

        /* =================================================
           NETFLIX-STYLE DETAILS MODAL
        ================================================= */

        .teacher-large-video-overlay{
          position:fixed;
          inset:0;
          z-index:9999999;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:24px;
          background:rgba(0,0,0,.76);
          backdrop-filter:blur(2px);
          -webkit-backdrop-filter:blur(2px);
        }

        .teacher-large-video-modal{
          position:relative;
          width:min(1120px,94vw);
          max-height:calc(100vh - 48px);
          background:#181818;
          border-radius:6px;
          overflow:hidden;
          box-shadow:0 24px 80px rgba(0,0,0,.9);
          animation:teacherNetflixOpen .18s ease-out;
        }

        @keyframes teacherNetflixOpen{
          from{
            opacity:0;
            transform:scale(.97);
          }
          to{
            opacity:1;
            transform:scale(1);
          }
        }

        .teacher-large-video-close{
          position:absolute;
          top:18px;
          right:18px;
          width:34px;
          height:34px;
          border:none;
          border-radius:50%;
          background:rgba(0,0,0,.72);
          color:#fff;
          font-size:25px;
          line-height:1;
          cursor:pointer;
          z-index:50;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:0;
        }

        .teacher-large-video-close:hover{
          background:rgba(255,255,255,.22);
        }

        .teacher-large-video-image{
          position:relative;
          width:100%;
          aspect-ratio:16 / 8.6;
          overflow:hidden;
          background:#000;
        }

        .teacher-large-video-image video{
          position:absolute;
          inset:0;
          width:100%;
          height:100%;
          display:block;
          object-fit:cover;
          object-position:center center;
          background:#000;
          z-index:1;
          opacity:0;
          transform:scale(1.025);
          transition:
            opacity 1.25s ease,
            transform 1.5s cubic-bezier(.22,1,.36,1);
        }

        .teacher-large-video-preview{
          position:absolute;
          inset:0;
          width:100%;
          height:100%;
          display:block;
          object-fit:cover;
          object-position:center center;
          background:#000;
          z-index:1;
          opacity:0;
          transform:scale(1.025);
          transition:opacity 1.25s ease,transform 1.5s cubic-bezier(.22,1,.36,1);
        }

        .teacher-large-video-preview.teacher-large-video-active{
          opacity:1;
          transform:scale(1);
        }

        .teacher-large-video-fallback{
          position:absolute;
          inset:0;
          width:100%;
          height:100%;
          object-fit:cover;
          display:block;
          z-index:0;
          opacity:1;
          transition:opacity 1.25s ease;
        }

        .teacher-large-video-fallback.teacher-large-image-hidden{
          opacity:0;
        }

        .teacher-large-video-gradient{
          position:absolute;
          inset:0;
          background:
            linear-gradient(
              90deg,
              rgba(0,0,0,.86) 0%,
              rgba(0,0,0,.54) 30%,
              rgba(0,0,0,.18) 55%,
              transparent 80%
            ),
            linear-gradient(
              0deg,
              rgba(0,0,0,.96) 0%,
              rgba(0,0,0,.45) 25%,
              transparent 63%
            );
          pointer-events:none;
          z-index:3;
        }

        .teacher-large-video-info{
          position:absolute;
          left:42px;
          top:50%;
          transform:translateY(-44%);
          width:min(430px,42%);
          z-index:5;
        }

        .teacher-large-video-meta{
          display:flex;
          align-items:center;
          flex-wrap:wrap;
          gap:9px;
          margin:0 0 10px;
          color:rgba(255,255,255,.88);
          font-size:13px;
          font-weight:600;
        }

        .teacher-large-video-meta span:not(:first-child)::before{
          content:"•";
          margin-right:9px;
          color:rgba(255,255,255,.5);
        }

        .teacher-large-video-info h1{
          margin:0 0 9px;
          color:#fff;
          font-size:40px;
          line-height:1.05;
          font-weight:800;
          text-shadow:0 3px 14px rgba(0,0,0,.9);
        }

        .teacher-large-video-info p{
          margin:0 0 14px;
          color:rgba(255,255,255,.86);
          font-size:13px;
          line-height:1.45;
          max-width:410px;
        }

        /* School statistics */
        .teacher-school-stats{
          display:grid;
          grid-template-columns:repeat(2,minmax(120px,1fr));
          gap:7px;
          width:100%;
          max-width:390px;
          margin:0 0 15px;
        }

        .teacher-school-stat{
          padding:7px 10px;
          border-radius:5px;
          background:rgba(0,0,0,.42);
          border:1px solid rgba(255,255,255,.13);
          backdrop-filter:blur(6px);
          -webkit-backdrop-filter:blur(6px);
        }

        .teacher-school-stat-label{
          display:block;
          margin-bottom:2px;
          color:rgba(255,255,255,.58);
          font-size:9px;
          text-transform:uppercase;
          letter-spacing:.45px;
          font-weight:700;
        }

        .teacher-school-stat-value{
          display:block;
          color:#fff;
          font-size:15px;
          line-height:1.1;
          font-weight:800;
        }

        .teacher-large-video-actions{
          display:flex;
          align-items:center;
          gap:9px;
        }

        .teacher-play-now-button,
        .teacher-resume-button{
          border:none;
          border-radius:4px;
          padding:10px 20px;
          font-size:14px;
          font-weight:700;
          cursor:pointer;
          display:flex;
          align-items:center;
          gap:7px;
          transition:background .2s ease,transform .2s ease;
        }

        .teacher-play-now-button{
          background:#fff;
          color:#000;
        }

        .teacher-play-now-button:hover{
          background:#ddd;
          transform:scale(1.02);
        }

        .teacher-resume-button{
          background:#fff;
          color:#000;
        }

        .teacher-resume-button:hover{
          background:#ddd;
          transform:scale(1.02);
        }

        .teacher-large-video-details{
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:20px;
          padding:18px 28px 22px;
          background:#181818;
          color:rgba(255,255,255,.75);
          font-size:13px;
          line-height:1.55;
        }

        .teacher-large-video-detail-main{
          min-width:0;
        }

        .teacher-large-video-detail-main strong{
          color:#fff;
        }

        .teacher-large-video-detail-side{
          color:rgba(255,255,255,.62);
        }

        .teacher-large-video-details span{
          display:inline-flex;
          align-items:center;
          margin-right:14px;
        }

        @media(max-width:768px){
          .teacher-large-video-overlay{
            padding:10px;
          }

          .teacher-large-video-modal{
            width:100%;
            max-height:calc(100vh - 20px);
            border-radius:5px;
          }

          .teacher-large-video-image{
            aspect-ratio:16 / 10.5;
          }

          .teacher-large-video-info{
            left:18px;
            right:18px;
            top:auto;
            bottom:32px;
            transform:none;
            width:auto;
            max-width:88%;
          }

          .teacher-large-video-info h1{
            font-size:25px;
            margin-bottom:7px;
          }

          .teacher-large-video-info p{
            font-size:11px;
            line-height:1.35;
            margin-bottom:9px;
          }

          .teacher-large-video-meta{
            font-size:10px;
            gap:7px;
            margin-bottom:7px;
          }

          .teacher-large-video-meta span:not(:first-child)::before{
            margin-right:7px;
          }

          .teacher-school-stats{
            grid-template-columns:repeat(2,minmax(100px,1fr));
            gap:5px;
            max-width:330px;
            margin-bottom:9px;
          }

          .teacher-school-stat{
            padding:5px 7px;
          }

          .teacher-school-stat-label{
            font-size:7px;
          }

          .teacher-school-stat-value{
            font-size:12px;
          }

          .teacher-large-video-actions{
            gap:6px;
          }

          .teacher-play-now-button,
          .teacher-resume-button{
            padding:8px 12px;
            font-size:11px;
          }

          .teacher-large-video-details{
            grid-template-columns:1fr;
            gap:7px;
            padding:13px 16px 16px;
            font-size:10px;
          }

          .teacher-large-video-close{
            top:8px;
            right:8px;
            width:32px;
            height:32px;
            font-size:22px;
          }
        }

        /* =================================================
           LIGHT MODE
        ================================================= */

        .teacher-demo-page.light-mode{
          background:#8fb8e6;
          color:#111;
        }

        .light-mode .teacher-demo-navbar{
          background:
            linear-gradient(
              180deg,
              #f4f9ff 0%,
              #eaf3fc 100%
            );

          border-bottom:
            1px solid
            rgba(0,0,0,.10);
        }

        .light-mode .teacher-demo-menu button{
          color:
            rgba(0,0,0,.65);
        }

        .light-mode .teacher-demo-menu button:hover{
          background:
            rgba(0,0,0,.07);

          color:#111;
        }

        .light-mode .teacher-demo-menu button.active{
          background:#e2e2e7;
          color:#111;
        }

        .light-mode .teacher-nav-icon{
          color:#111;
        }

        .light-mode .teacher-nav-icon:hover,
        .light-mode .teacher-nav-icon.active{
          background:#e5e5e5;
        }

        .light-mode .teacher-theme-toggle{
          color:#111;
        }

        .light-mode .teacher-theme-toggle:hover{
          background:#e5e5e5;
        }

        .light-mode .teacher-mobile-menu-button{
          color:#111;
        }

        .light-mode .teacher-mobile-menu-button:hover,
        .light-mode .teacher-mobile-menu-button.active{
          background:#e5e5e5;
        }

        .light-mode .teacher-mobile-menu-panel{
          background:#f4f9ff;

          border-color:
            rgba(0,0,0,.12);

          box-shadow:
            0 15px 40px
            rgba(0,0,0,.25);
        }

        .light-mode .teacher-mobile-menu-panel button{
          color:#333;
        }

        .light-mode .teacher-mobile-menu-panel button:hover{
          background:#e5edf6;
          color:#111;
        }

        .light-mode .teacher-mobile-menu-panel button.active{
          background:#dce8f5;
          color:#111;
        }

        .light-mode .teacher-kids-item{
          color:#111;
        }

        .light-mode .teacher-kids-item:hover{
          background:#e5e5e5;
        }

        .light-mode .teacher-category-title{
          color:#111;
        }

        .light-mode .teacher-scroll-indicator .scroll-dash{
          background:
            rgba(0,0,0,.25);
        }

        .light-mode .teacher-scroll-indicator .scroll-dash.active{
          background:#111;
        }

        .light-mode .teacher-card{
          background:#fff;
        }

        .light-mode .teacher-selected-popup{
          background:#fff;

          box-shadow:
            0 20px 60px
            rgba(0,0,0,.25);
        }

        .light-mode .teacher-popup-content{
          background:#fff;
        }

        .light-mode .teacher-popup-content h3{
          color:#111;
        }

        .light-mode .teacher-detail-label{
          color:#111;
        }

        .light-mode .teacher-detail-value{
          color:#555;
        }

        .light-mode .teacher-description{
          color:#555;
        }

        .light-mode .teacher-buttons button{
          color:#111;

          border-color:
            rgba(0,0,0,.25);

          background:
            rgba(0,0,0,.05);
        }

        .light-mode .teacher-buttons button:hover{
          background:#111;
          color:#fff;
        }

        .light-mode .teacher-search-input{
          background:#fff;

          color:#111;

          border-color:
            rgba(0,0,0,.20);
        }

        .light-mode .teacher-search-input::placeholder{
          color:
            rgba(0,0,0,.45);
        }

        /* =================================================
           MOBILE
        ================================================= */

        @media(max-width:768px){

          .teacher-demo-page{
            padding:
              0 29px 45px;
          }

          .teacher-demo-navbar{

            height:72px;

            margin:
              0 -29px 27px;

            padding:
              0 14px;

            justify-content:flex-end;
          }

          /*
           * Desktop menu is hidden on mobile.
           * Mobile menu button is shown instead.
           */

          .teacher-demo-navbar-left{
            display:none;
          }

          .teacher-netflix-logo{
            display:none;
          }

          .teacher-demo-menu{
            display:none;
          }

          .teacher-mobile-menu-button{
            display:flex;

            /* Keep the menu icon on the LEFT side */
            position:absolute;
            left:14px;
            top:17px;

            width:38px;
            height:38px;

            margin:0;
          }

          .teacher-mobile-menu-panel{
            display:block;
          }

          /* =================================================
             NAVBAR RIGHT
          ================================================= */

          .teacher-demo-navbar-right{

            display:flex;

            align-items:center;

            justify-content:flex-end;

            gap:5px;

            width:100%;

            padding-left:50px;
          }

          /* =================================================
             THEME
          ================================================= */

          .teacher-theme-toggle{
            width:38px;
            height:38px;

            flex-shrink:0;
          }

          /* =================================================
             SEARCH
          ================================================= */

          .teacher-search-area{

            display:flex;

            align-items:center;

            position:relative;

            flex-shrink:0;
          }

          .teacher-nav-icon{

            width:38px;
            height:38px;

            flex-shrink:0;
          }

          /* =================================================
             NOTIFICATION
          ================================================= */

          .teacher-notification-icon{
            width:22px;
            height:22px;
          }

          /* =================================================
             KIDS
          ================================================= */

          .teacher-kids-item{

            width:38px;
            min-width:38px;

            height:38px;

            padding:0;

            gap:0;

            flex-shrink:0;
          }

          .teacher-kids-text{
            display:none;
          }

          .teacher-kids-arrow{
            display:none;
          }

          .teacher-kids-logo{
            width:32px;
            height:32px;
          }

          /* =================================================
             PROFILE
          ================================================= */

          .teacher-profile-icon{

            width:38px;
            height:38px;

            flex-shrink:0;
          }

          .teacher-profile-arrow{
            display:none;
          }

          /* =================================================
             SEARCH BOX
          ================================================= */

          .teacher-search-input{

            position:fixed;

            top:82px;

            left:15px;

            right:15px;

            width:auto;

            max-width:none;

            height:42px;

            z-index:6000;

            border-radius:6px;

            box-shadow:
              0 8px 25px
              rgba(0,0,0,.45);

            padding:
              0 13px;

            font-size:14px;
          }

          /* =================================================
             CATEGORY
          ================================================= */

          .teacher-category{
            margin-bottom:27px;
          }

          .teacher-category-title{
            font-size:22px;
            white-space:nowrap;
          }

          .teacher-scroll-indicator{
            display:none;
          }

          /* =================================================
             HORIZONTAL CARDS
          ================================================= */

          .teacher-row{

            gap:10px;

            padding:
              5px 20px 9px 0;

            margin:
              0 -20px 0 0;
          }

          .teacher-card{

            width:277px;

            min-width:277px;

            flex:
              0 0 277px;

            aspect-ratio:16 / 9;
          }

          .teacher-image{
            object-position:center center;
          }

          .teacher-card-name{
            font-size:17px;
          }

          /* =================================================
             MOBILE POPUP
          ================================================= */

          .teacher-selected-popup{

            width:
              calc(100vw - 20px);

            height:
              calc(100vw - 20px);

            max-width:378px;

            max-height:378px;
          }

          .teacher-popup-image-wrapper{

            height:
              calc(
                (100vw - 20px) * .5625
              );

            max-height:212px;
          }

          .teacher-popup-content{

            height:
              calc(
                100vw - 20px -
                (
                  (100vw - 20px) * .5625
                )
              );

            max-height:166px;

            padding:
              8px 13px 10px;
          }

          .teacher-popup-content h3{
            font-size:17px;
          }

          .teacher-details{
            font-size:11px;
          }

          .teacher-description{
            font-size:10px;
          }

        }

        /* =================================================
           DESKTOP
        ================================================= */

        @media(min-width:769px){

          .teacher-demo-menu{
            display:flex;
          }

          .teacher-demo-navbar-right{
            display:flex;
          }

          .teacher-mobile-menu-button{
            display:none;
          }

          .teacher-mobile-menu-panel{
            display:none;
          }

        }

      `}</style>

      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <nav className="teacher-demo-navbar">

        <div className="teacher-demo-navbar-left">

          <div className="teacher-netflix-logo">
            NETFLIX
          </div>

          <div className="teacher-demo-menu">

            {[
              "Home",
              "Teachers",
              "Subjects",
              "My Learning"
            ].map(item=>(

              <button
                key={item}
                type="button"
                className={
                  activeNav===item
                    ?"active"
                    :""
                }
                onClick={()=>
                  handleNavClick(item)
                }
              >

                {item}

              </button>

            ))}

          </div>

        </div>

        {/* =====================================================
            NAVBAR RIGHT
        ===================================================== */}

        <div className="teacher-demo-navbar-right">

          {/* =================================================
              MOBILE MENU
          ================================================= */}

          <button
            className={
              `teacher-mobile-menu-button ${
                mobileMenuOpen
                  ?"active"
                  :""
              }`
            }

            type="button"

            title="Menu"

            aria-label="Open menu"

            onClick={()=>{

              setMobileMenuOpen(
                current=>!current
              );

              setSearchOpen(false);

              setSearchText("");

            }}
          >

            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >

              <line
                x1="4"
                y1="6"
                x2="20"
                y2="6"
              />

              <line
                x1="4"
                y1="12"
                x2="20"
                y2="12"
              />

              <line
                x1="4"
                y1="18"
                x2="20"
                y2="18"
              />

            </svg>

          </button>

          {/* =================================================
              DARK / LIGHT
          ================================================= */}

          <button
            className="teacher-theme-toggle"

            type="button"

            title={
              darkMode
                ?"Light Mode"
                :"Dark Mode"
            }

            aria-label={
              darkMode
                ?"Switch to light mode"
                :"Switch to dark mode"
            }

            onClick={()=>
              setDarkMode(current=>!current)
            }
          >

            {darkMode ? (

              <svg
                viewBox="0 0 24 24"
                fill="none"
              >

                <circle
                  cx="12"
                  cy="12"
                  r="4"
                />

                <path d="M12 2v2"/>
                <path d="M12 20v2"/>
                <path d="m4.93 4.93 1.41 1.41"/>
                <path d="m17.66 17.66 1.41 1.41"/>
                <path d="M2 12h2"/>
                <path d="M20 12h2"/>
                <path d="m4.93 19.07 1.41-1.41"/>
                <path d="m17.66 6.34 1.41-1.41"/>

              </svg>

            ) : (

              <svg
                viewBox="0 0 24 24"
                fill="none"
              >

                <path
                  d="
                    M21 12.79
                    A9 9 0 1 1 11.21 3
                    7 7 0 0 0 21 12.79Z
                  "
                />

              </svg>

            )}

          </button>

          {/* =================================================
              SEARCH
          ================================================= */}

          <div className="teacher-search-area">

            {searchOpen&&(

              <input
                type="text"

                className="teacher-search-input"

                placeholder="Search..."

                value={searchText}

                onChange={event=>
                  setSearchText(
                    event.target.value
                  )
                }

                autoFocus
              />

            )}

            <button
              className={
                `teacher-nav-icon ${
                  searchOpen
                    ?"active"
                    :""
                }`
              }

              type="button"

              title="Search"

              onClick={()=>{

                setSearchOpen(
                  current=>!current
                );

                setMobileMenuOpen(false);

                if(searchOpen){

                  setSearchText("");

                }

              }}
            >

              <svg
                className={
                  "teacher-nav-svg " +
                  "teacher-search-icon"
                }

                viewBox="0 0 24 24"

                fill="none"

                stroke="currentColor"

                strokeWidth="2"

                strokeLinecap="round"

                strokeLinejoin="round"
              >

                <circle
                  cx="11"
                  cy="11"
                  r="7"
                />

                <line
                  x1="16.5"
                  y1="16.5"
                  x2="21"
                  y2="21"
                />

              </svg>

            </button>

          </div>

          {/* =================================================
              NOTIFICATION
          ================================================= */}

          <button
            className="teacher-nav-icon"

            type="button"

            title="Notifications"
          >

            <svg
              className={
                "teacher-nav-svg " +
                "teacher-notification-icon"
              }

              viewBox="0 0 24 24"

              fill="none"

              stroke="currentColor"

              strokeWidth="2"

              strokeLinecap="round"

              strokeLinejoin="round"
            >

              <path
                d="
                  M18 8
                  a6 6 0 0 0-12 0
                  c0 7-3 7-3 9
                  h18
                  c0-2-3-2-3-9
                "
              />

              <path d="M10 21h4"/>

            </svg>

          </button>

          {/* =================================================
              KIDS
          ================================================= */}

          <button
            className="teacher-kids-item"

            type="button"

            title="Switch account"

            onClick={()=>
              setAccountName("Kids")
            }
          >

            <span className="teacher-kids-logo">

              <span>
                kids
              </span>

            </span>

            <span className="teacher-kids-text">
              {accountName}
            </span>

            <svg
              className="teacher-kids-arrow"

              viewBox="0 0 10 10"

              fill="none"

              stroke="currentColor"

              strokeWidth="1.5"
            >

              <path
                d="M2 3.5 5 6.5 8 3.5"
              />

            </svg>

          </button>

          {/* =================================================
              PROFILE
          ================================================= */}

          <div
            className="teacher-profile-icon"

            onClick={()=>
              navigate("/profile")
            }

            title="Profile"

            role="button"

            tabIndex="0"
          >

            <svg
              className="teacher-profile-svg"

              viewBox="0 0 24 24"

              fill="none"

              stroke="currentColor"

              strokeWidth="1.8"

              strokeLinecap="round"

              strokeLinejoin="round"
            >

              <circle
                cx="8"
                cy="8"
                r="1.2"
                fill="currentColor"
              />

              <circle
                cx="16"
                cy="8"
                r="1.2"
                fill="currentColor"
              />

              <path
                d="
                  M7 14
                  c2.2 2 7.8 2 10 0
                "
              />

            </svg>

          </div>

          <svg
            className="teacher-profile-arrow"

            viewBox="0 0 10 10"

            fill="none"

            stroke="currentColor"

            strokeWidth="1.5"
          >

            <path
              d="M2 3.5 5 6.5 8 3.5"
            />

          </svg>

        </div>

      </nav>

      {/* =====================================================
          MOBILE MENU
      ===================================================== */}

      {mobileMenuOpen&&(

        <div className="teacher-mobile-menu-panel">

          {[
            "Home",
            "Teachers",
            "Subjects",
            "My Learning"
          ].map(item=>(

            <button
              key={item}

              type="button"

              className={
                activeNav===item
                  ?"active"
                  :""
              }

              onClick={()=>
                handleNavClick(item)
              }
            >

              {item}

            </button>

          ))}

        </div>

      )}

      {/* =====================================================
          ROWS
      ===================================================== */}

      {filteredRows.map(row=>{

        const dashCount=8;

        const scrollPercentage=
          scrollPositions[row.title]||0;

        let activeDash=
          Math.round(
            scrollPercentage*
            (dashCount-1)
          );

        if(activeDash<0){
          activeDash=0;
        }

        if(activeDash>dashCount-1){
          activeDash=dashCount-1;
        }

        return(

          <section
            key={row.title}

            className="teacher-category"
          >

            <div
              className=
                "teacher-category-header"
            >

              <h2
                className=
                  "teacher-category-title"
              >

                {row.title}

              </h2>

              <div
                className=
                  "teacher-scroll-indicator"

                aria-hidden="true"
              >

                {Array.from({
                  length:dashCount
                }).map((_,index)=>(

                  <span
                    key={index}

                    className={
                      `scroll-dash ${
                        index===activeDash
                          ?"active"
                          :""
                      }`
                    }
                  ></span>

                ))}

              </div>

            </div>

            <div
              className=
                "teacher-row-wrapper"
            >

              <div
                ref={element=>{

                  rowRefs.current[
                    row.title
                  ]=element;

                }}

                className="teacher-row"

                onScroll={event=>
                  handleRowScroll(
                    row.title,
                    event
                  )
                }
              >

                {row.items.map(
                  (item,index)=>(

                    <div
                      key={
                        item.id+
                        "_"+
                        index
                      }

                      className="teacher-card"

                      onMouseEnter={event=>{

                        handleItemHover(
                          item,
                          row.type,
                          event.currentTarget
                        );

                      }}

                      onMouseLeave={
                        handleItemLeave
                      }

                      onClick={()=>{

                        handleItemClick(
                          item,
                          row.type
                        );

                      }}
                    >

                      <div
                        className=
                          "teacher-image-box"
                      >

                        <img
                          src={item.image}

                          alt={item.name}

                          className=
                            "teacher-image"

                          loading="lazy"

                          onError={event=>{

                            handleImageError(
                              event,
                              row.type
                            );

                          }}
                        />

                      </div>

                      <div
                        className=
                          "teacher-card-badge"
                      >

                        {index<2
                          ?"Top 10"
                          :row.type}

                      </div>

                      {(item.subject||
                        item.location)&&(

                        <div
                          className=
                            "teacher-card-small-info"
                        >

                          {item.subject||
                            item.location}

                        </div>

                      )}

                      <div
                        className=
                          "teacher-card-name"
                      >

                        {item.name}

                      </div>

                    </div>

                  )
                )}

              </div>

            </div>

          </section>

        );

      })}

      {/* =====================================================
          HOVER POPUP
      ===================================================== */}

      {selectedItem&&(

        <div
          ref={popupRef}

          className=
            "teacher-selected-popup"

          style={{
            top:
              `${popupPosition.top}px`,

            left:
              `${popupPosition.left}px`
          }}

          onMouseEnter={
            handlePopupMouseEnter
          }

          onMouseLeave={
            handlePopupMouseLeave
          }
        >

          <div
            className=
              "teacher-popup-image-wrapper"

            onClick={() => {
              setShowLargeVideo(true);
            }}

            role="button"

            tabIndex={0}

            onKeyDown={event => {
              if(
                event.key === "Enter" ||
                event.key === " "
              ){
                event.preventDefault();
                setShowLargeVideo(true);
              }
            }}

            aria-label="Open preview"
          >

            {previewVideos[selectedType] ? (

              <video
                key={
                  selectedType+
                  "-"+
                  selectedItem.id
                }

                ref={videoRef}

                src={
                  previewVideos[
                    selectedType
                  ]
                }

                className={
                  `teacher-popup-video ${
                    videoReady
                      ?"video-ready"
                      :""
                  }`
                }

                muted={videoMuted}

                loop

                playsInline

                preload="auto"

                onLoadedMetadata={event=>{

                  event.currentTarget
                    .defaultPlaybackRate=.85;

                  event.currentTarget
                    .playbackRate=.85;

                }}

                onCanPlay={event=>{

                  event.currentTarget
                    .defaultPlaybackRate=.85;

                  event.currentTarget
                    .playbackRate=.85;

                  setVideoCanPlay(true);

                }}

                onError={event=>{

                  setVideoReady(false);

                  setVideoCanPlay(false);

                  event.currentTarget
                    .style.display="none";

                  const image=
                    event.currentTarget
                      .parentElement
                      .querySelector(
                        ".teacher-popup-image"
                      );

                  if(image){
                    image.style.display="block";
                  }

                }}
              />

            ):null}

            <img
              src={selectedItem.image}

              alt={selectedItem.name}

              className="teacher-popup-image"

              style={{
                opacity:
                  showPreviewVideo
                    ?0
                    :1
              }}

              onError={event=>{

                handleImageError(
                  event,
                  selectedType
                );

              }}
            />


          </div>

          <div
            className=
              "teacher-popup-content"
          >

            <div className="teacher-buttons">

              <button
                onClick={event=>
                  event.stopPropagation()
                }
              >
                +
              </button>

              <button
                onClick={event=>
                  event.stopPropagation()
                }
              >
                👍
              </button>

            </div>

            <h3>
              {selectedItem.name}
            </h3>

            <div className="teacher-details">

              <div
                className=
                  "teacher-detail-row"
              >

                <span
                  className=
                    "teacher-detail-label"
                >
                  Type -
                </span>

                <span
                  className=
                    "teacher-detail-value"
                >
                  {selectedType}
                </span>

              </div>

              {selectedItem.subject&&(

                <div
                  className=
                    "teacher-detail-row"
                >

                  <span
                    className=
                      "teacher-detail-label"
                  >
                    Subject -
                  </span>

                  <span
                    className=
                      "teacher-detail-value"
                  >
                    {selectedItem.subject}
                  </span>

                </div>

              )}

              {selectedItem.grade&&(

                <div
                  className=
                    "teacher-detail-row"
                >

                  <span
                    className=
                      "teacher-detail-label"
                  >
                    Grade -
                  </span>

                  <span
                    className=
                      "teacher-detail-value"
                >
                  {selectedItem.grade}
                </span>

                </div>

              )}

              {selectedItem.location&&(

                <div
                  className=
                    "teacher-detail-row"
                >

                  <span
                    className=
                      "teacher-detail-label"
                  >
                    Location -
                  </span>

                  <span
                    className=
                      "teacher-detail-value"
                  >
                    {selectedItem.location}
                  </span>

                </div>

              )}

            </div>

            <p
              className=
                "teacher-description"
            >

              Explore more learning
              opportunities with{" "}
              {selectedItem.name}.

            </p>

          </div>

        </div>

      )}

      {/* =====================================================
          NETFLIX-STYLE DETAILS MODAL
      ===================================================== */}

      {showLargeVideo && selectedItem && (

        <div
          className="teacher-large-video-overlay"
          onClick={() => setShowLargeVideo(false)}
        >

          <div
            className="teacher-large-video-modal"
            onClick={event => event.stopPropagation()}
          >

            <button
              type="button"
              className="teacher-large-video-close"
              aria-label="Close"
              onClick={() => setShowLargeVideo(false)}
            >
              ×
            </button>

            <div className="teacher-large-video-image">

              <img
                src={selectedItem.image}
                alt={selectedItem.name}
                className={`teacher-large-video-fallback ${showPreviewVideo ? "teacher-large-image-hidden" : ""}`}
                onError={event => {
                  handleImageError(event,selectedType);
                }}
              />

              {previewVideos[selectedType] && (
                <video
                  ref={largeVideoRef}
                  className={`teacher-large-video-preview ${showPreviewVideo ? "teacher-large-video-active" : ""}`}
                  src={previewVideos[selectedType]}
                  muted
                  loop
                  playsInline
                  preload="auto"
                  onEnded={event => {
                    event.currentTarget.currentTime=0;
                    event.currentTarget.play().catch(()=>{});
                  }}
                  onLoadedData={() => {
                    if(showPreviewVideo && largeVideoRef.current){
                      largeVideoRef.current.currentTime=0;
                      largeVideoRef.current.play().catch(()=>{});
                    }
                  }}
                  onError={() => {}}
                />
              )}

              <div className="teacher-large-video-gradient"></div>

              <div className="teacher-large-video-info">

                <div className="teacher-large-video-meta">
                  <span>{selectedType}</span>

                  {selectedItem.grade && (
                    <span>{selectedItem.grade}</span>
                  )}

                  {selectedItem.location && (
                    <span>{selectedItem.location}</span>
                  )}
                </div>

                <h1>
                  {selectedItem.name}
                </h1>

                <p>
                  Explore more learning opportunities with {selectedItem.name}.
                </p>

                {selectedType === "School" && (
                  (() => {
                    const stats=getSchoolStats(selectedItem);

                    return stats ? (
                      <div className="teacher-school-stats">

                        <div className="teacher-school-stat">
                          <span className="teacher-school-stat-label">
                            Total Students
                          </span>
                          <span className="teacher-school-stat-value">
                            {stats.students}
                          </span>
                        </div>

                        <div className="teacher-school-stat">
                          <span className="teacher-school-stat-label">
                            Total Teachers
                          </span>
                          <span className="teacher-school-stat-value">
                            {stats.teachers}
                          </span>
                        </div>

                        <div className="teacher-school-stat">
                          <span className="teacher-school-stat-label">
                            School Rank
                          </span>
                          <span className="teacher-school-stat-value">
                            {stats.rank}
                          </span>
                        </div>

                        <div className="teacher-school-stat">
                          <span className="teacher-school-stat-label">
                            Subjects
                          </span>
                          <span className="teacher-school-stat-value">
                            {stats.subjects}
                          </span>
                        </div>

                        <div className="teacher-school-stat">
                          <span className="teacher-school-stat-label">
                            Active Lessons
                          </span>
                          <span className="teacher-school-stat-value">
                            {stats.lessons}
                          </span>
                        </div>

                      </div>
                    ) : null;
                  })()
                )}

                <div className="teacher-large-video-actions">

                  <button
                    type="button"
                    className="teacher-resume-button"
                    onClick={() => {
                      window.location.href="/grade-selection";
                    }}
                  >
                    ▶ Start
                  </button>

                </div>

              </div>

            </div>

            <div className="teacher-large-video-details">

              <div className="teacher-large-video-detail-main">

                <span>
                  <strong>{selectedType}</strong>
                </span>

                {selectedItem.subject && (
                  <span>{selectedItem.subject}</span>
                )}

                {selectedItem.grade && (
                  <span>{selectedItem.grade}</span>
                )}

                {selectedItem.location && (
                  <span>{selectedItem.location}</span>
                )}

              </div>

              <div className="teacher-large-video-detail-side">
                {selectedType === "School" && (
                  <>School learning and educational opportunities.</>
                )}

                {selectedType === "Teacher" && (
                  <>Teacher profile and subject learning opportunities.</>
                )}

                {selectedType === "Lesson" && (
                  <>Lesson content and learning opportunities.</>
                )}
              </div>

            </div>

          </div>

        </div>

      )}

    </div>

  );

}

export default TeacherDemo;

